/* Healora home clone: header dropdowns + drawer, result tabs, carousels, video slider, FAQ and footer accordions.
   Event delegation on document so it keeps working after the theme editor re-renders a section. */
(function () {
  if (window.__hlHomeInit) return;
  window.__hlHomeInit = true;

  function closeDropdowns(except) {
    document.querySelectorAll('.hl-nav-dd.is-open').forEach(function (dd) {
      if (dd === except) return;
      dd.classList.remove('is-open');
      var b = dd.querySelector(':scope > button');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function setDrawer(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function scrollTrack(track, dir) {
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) : track.clientWidth;
    track.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    // Header dropdown
    var ddBtn = t.closest('.hl-nav-dd > button');
    if (ddBtn) {
      var dd = ddBtn.parentElement;
      var open = !dd.classList.contains('is-open');
      closeDropdowns(dd);
      dd.classList.toggle('is-open', open);
      ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!t.closest('.hl-nav-dd')) closeDropdowns(null);

    // Mobile drawer
    var openBtn = t.closest('[data-hl-drawer-open]');
    if (openBtn) {
      setDrawer(document.getElementById(openBtn.getAttribute('data-hl-drawer-open')), true);
      return;
    }
    var closeBtn = t.closest('[data-hl-drawer-close]');
    if (closeBtn) {
      setDrawer(closeBtn.closest('.hl-drawer'), false);
      return;
    }
    if (t.closest('.hl-drawer a')) setDrawer(t.closest('.hl-drawer'), false);

    // Result tabs
    var tab = t.closest('.hl-tab');
    if (tab) {
      var root = tab.closest('.hl-results');
      root.querySelectorAll('.hl-tab').forEach(function (b) {
        b.setAttribute('aria-selected', b === tab ? 'true' : 'false');
      });
      root.querySelectorAll('.hl-panel').forEach(function (p) {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
      return;
    }

    // Review carousel arrows (mobile)
    var carBtn = t.closest('.hl-car-nav button');
    if (carBtn) {
      scrollTrack(carBtn.closest('.hl-panel').querySelector('.hl-track'), carBtn.getAttribute('data-dir'));
      return;
    }

    // Video slider arrows
    var varr = t.closest('.hl-varr');
    if (varr) {
      scrollTrack(varr.closest('.hl-vrow').querySelector('.hl-vtrack'), varr.getAttribute('data-dir'));
      return;
    }

    // Video play
    var play = t.closest('.hl-vplay');
    if (play) {
      var card = play.closest('.hl-vcard');
      var video = card.querySelector('video');
      if (!video) return;
      document.querySelectorAll('.hl-vcard.is-playing video').forEach(function (v) {
        if (v !== video) { v.pause(); v.closest('.hl-vcard').classList.remove('is-playing'); }
      });
      var src = video.getAttribute('data-src');
      if (src && !video.getAttribute('src') && !video.querySelector('source')) video.setAttribute('src', src);
      video.controls = true;
      card.classList.add('is-playing');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }

    // FAQ accordion
    var qa = t.closest('.hl-qa > button');
    if (qa) {
      var item = qa.parentElement;
      var ans = item.querySelector('.hl-qa-a');
      var isOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open', isOpen);
      qa.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (ans) ans.hidden = !isOpen;
      return;
    }

    // Footer accordion (mobile only; on desktop the lists are always shown)
    var fcol = t.closest('.hl-ftr-col h2 button');
    if (fcol) {
      var col = fcol.closest('.hl-ftr-col');
      var o = !col.classList.contains('is-open');
      col.classList.toggle('is-open', o);
      fcol.setAttribute('aria-expanded', o ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDropdowns(null);
    document.querySelectorAll('.hl-drawer.is-open').forEach(function (d) { setDrawer(d, false); });
  });

  document.addEventListener('ended', function (e) {
    if (e.target.matches && e.target.matches('.hl-vcard video')) e.target.closest('.hl-vcard').classList.remove('is-playing');
  }, true);

  // Science dots follow the mobile scroll position
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.classList || !track.classList.contains('hl-sci-track')) return;
    var dots = track.parentElement.querySelectorAll('.hl-dots i');
    if (!dots.length) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
  }, true);
})();
